import React, { Component } from "react";
import { Button, Col, Form, InputNumber, Popconfirm, Row, Select, Table } from "antd";

import { ArrowLeftOutlined } from "@ant-design/icons";
import Column from "antd/lib/table/Column";
import { formatDateToAPP, getInfoLocataireSimple } from "../../utils/tools";
import CustomSelect from "../CustomFormItem/Select";
import CustomDatePicker from "../CustomFormItem/DatePicker";
import CustomInput from "../CustomFormItem/Input";

import { toast } from "react-toastify";

import dayjs from "dayjs";

const { Option, OptGroup } = Select;

class FormReglement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      journal: null,
      montants: [],
      reglements: [],
      lignesReglements: [],
      selectedRowKeys: [],
      selectedRows: [],
      hidden: false,
      nomLocataire: "",
      prenomLocataire: "",
      dateReglement: null,
      typePaiement: this.props.typesPaiements[0].type_paiement_id,
      numeroCheque: "",
      libelle: "",
      montantReglement: 0,
      quittanceLignes: [],
      tropPercu: false,
      popConfirmOpen: false,
      loading: false,
      isAcompte: false,
    };
  }

  formRef = React.createRef();

  componentDidMount() {
    if (this.props.journals) {
      this.init();
    }
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const idLocataire = this.state.idLocataire;
    if (idLocataire && idLocataire !== nextProps.idLocataire) {
      this.onSelectLocataire(idLocataire, nextProps.reglements);
    }
  };

  init = () => {
    const jouralsFiltered = this.props.journals.filter((item) => item.journal_de_banque === true)[0]
      ?.journal_id;
    this.formRef.current.setFieldsValue({
      ecriture_journal_id: jouralsFiltered ? jouralsFiltered : null,
      typePaiement: this.props.typesPaiements[0].type_paiement_id,
    });
    this.setState(
      {
        journal: jouralsFiltered ? jouralsFiltered : null,
        typePaiement: this.props.typesPaiements[0].type_paiement_id,
      },
      () => {
        if (this.props.idLocataire) {
          this.formRef.current.setFieldsValue({ requete_locataire_id: this.props.idLocataire });
          this.setState({ idLocataire: this.props.idLocataire });
          this.onSelectLocataire(this.props.idLocataire);
        }
      }
    );
  };

  reset = () => {
    this.setState({ loading: false }, () => {
      this.resetReglements();
      this.uncheckAll();
    });
  };

  onChangeJournal = (id) => {
    this.setState({ journal: id });
  };

  onSelectLocataire = (idLocataire, propsReglements) => {
    const result = [];
    let lignesReglements = [];
    const locataire = this.props.locataires.find((item) => item.locataire_id === idLocataire);
    // Quittances de l'exercice uniquement : celles de l'historique locataire n'ont pas
    // leurs règlements reddités dans le store et apparaîtraient à tort comme dues
    const horsExercice = new Set(this.props.quittancesHorsExercice);
    const quittances =
      this.props.quittances &&
      this.props.quittances.filter((item) => !horsExercice.has(item.quittance_id));
    const reglements = propsReglements ? propsReglements : this.props.reglements;
    const locations = this.props.locations.filter(
      (loc) =>
        loc.location_requete &&
        loc.location_requete.requete_locataire?.locataire_id === idLocataire &&
        loc.location_etat !== "a"
    );

    let datePaiement = this.state.dateReglement;
    if (quittances) {
      locations.forEach((location) => {
        let acompte = 0;
        if (location.location_etat === "r") {
          location.location_ligne.forEach((ligne) => {
            acompte +=
              (parseFloat(ligne.location_ligne_montant) *
                parseFloat(ligne.location_ligne_pourcentage_acompte)) /
              100;
          });
          acompte = parseFloat(acompte).toFixed(2);
        }

        quittances
          .filter((quit) => quit.quittance_location_id === location.location_id)
          .sort((a, b) => a.quittance_id - b.quittance_id)
          .forEach((quittance) => {
            const filteredReglement =
              reglements &&
              reglements.filter(
                (regl) => quittance.quittance_id === regl.reglement_quittance.quittance_id
              );

            let montantPaye = 0;
            let total = 0;
            quittance.quittance_ligne.forEach((ligne) => {
              total +=
                parseFloat(ligne.quittance_ligne_montant) *
                parseInt(ligne.quittance_ligne_quantite);
            });
            total = parseFloat(total).toFixed(2);

            filteredReglement &&
            filteredReglement.forEach((regl) => {
              montantPaye += parseFloat(regl.reglement_montant, 2);
              lignesReglements = [...lignesReglements, ...regl.reglement_ligne];
            });
            let resteDu = parseFloat(total - montantPaye).toFixed(2);
            montantPaye = parseFloat(montantPaye).toFixed(2);

            if (!datePaiement) datePaiement = quittance.quittance_date_paiement;

            // Montant déjà réglé par ligne quittance
            quittance.quittance_ligne.map((item) => {
              const lignesReglementsFiltered = lignesReglements.filter(
                (reg) =>
                  reg.reglement_ligne_quittance_ligne_id.quittance_ligne_id ===
                  item.quittance_ligne_id
              );
              item.quittance_ligne_regle = lignesReglementsFiltered.reduce(
                (a, b) => a + parseFloat(b.reglement_ligne_montant),
                0
              );
              const locationLigne = location.location_ligne.find(
                (ligne) =>
                  ligne.location_ligne_rubrique.rubrique_id ===
                  item.quittance_ligne_rubrique.rubrique_id
              );
              item.quittance_ligne_acompte = locationLigne
                ? parseFloat(
                parseFloat(item.quittance_ligne_montant * item.quittance_ligne_quantite) *
                parseFloat(locationLigne.location_ligne_pourcentage_acompte)
              ) / 100
                : 0;
              return item;
            });

            quittance.quittance_ligne = this.sortedAsc(quittance.quittance_ligne);

            const reglement = {
              quittance_id: quittance.quittance_id,
              quittance_ligne: quittance.quittance_ligne,
              location_id: location.location_id,
              appartement: location.location_lot.lot_reference,
              date:
                quittance.quittance_date_paiement !== null
                  ? formatDateToAPP(quittance.quittance_date_paiement)
                  : "Non renseigné",
              date_debut: formatDateToAPP(quittance.quittance_date_debut),
              date_fin: formatDateToAPP(quittance.quittance_date_fin),
              total: total,
              acompte: acompte,
              paye: montantPaye,
              du: resteDu,
              reglement: 0,
              expand: false,
            };
            result.push(reglement);
          });
      });
      this.formRef.current.resetFields(["montant_reglement"]);
      this.formRef.current.setFieldsValue({
        date: datePaiement ? dayjs(datePaiement, "DD/MM/YYYY") : null,
      });
    }
    this.setState(
      {
        montants: [],
        reglements: result,
        lignesReglements,
        nomLocataire: locataire ? locataire.locataire_personne.personne_nom : "",
        prenomLocataire: locataire ? locataire.locataire_personne.personne_prenom : "",
        dateReglement: datePaiement ? dayjs(datePaiement, "DD/MM/YYYY") : null,
        // isAcompte: false,
      },
      () => {
        this.uncheckAll();
        this.onChangeLibelle();
      }
    );
  };

  sortedAsc = (arr) => {
    return arr.sort((a, b) => {
      if (a.quittance_ligne_rubrique.rubrique_ordre === null) {
        return 1;
      }

      if (b.quittance_ligne_rubrique.rubrique_ordre === null) {
        return -1;
      }

      if (a.quittance_ligne_rubrique.rubrique_ordre === b.quittance_ligne_rubrique.rubrique_ordre) {
        return 0;
      }

      return a.quittance_ligne_rubrique.rubrique_ordre - b.quittance_ligne_rubrique.rubrique_ordre;
    });
  };

  prepareReglementsLignes = (reglements) => {
    const quittances = this.props.quittances;
    const locations = this.props.locations;
    let reglementsLignes = [];
    let montantRestant = 0;
    reglements.forEach((reglement) => {
      // Imputation automatique ou manuelle ?
      const imputationManuelle = this.state.quittanceLignes.length > 0;
      montantRestant = reglement.reglement_montant;
      // Get lignes reglements
      const lignesReglements = this.state.lignesReglements;
      // Get quittance from reglement
      const quittance = quittances.find(
        (quittance) => quittance.quittance_id === reglement.reglement_quittance.quittance_id
      );
      // Get location from quittance
      const location = locations.find(
        (location) => quittance.quittance_location_id === location.location_id
      );
      // Mode acompte ?
      let modeAcompte = false;
      let acompte = 0;
      location.location_ligne.forEach((ligne) => {
        acompte +=
          (parseFloat(ligne.location_ligne_montant) *
            parseFloat(ligne.location_ligne_pourcentage_acompte)) /
          100;
      });
      acompte = parseFloat(acompte);
      if (
        this.state.isAcompte &&
        parseFloat(reglement.reglement_montant) === acompte &&
        !imputationManuelle &&
        lignesReglements.filter(
          (ligne) =>
            ligne.reglement_ligne_quittance_ligne_id.quittance_ligne_quittance_id ===
            reglement.reglement_quittance.quittance_id
        ).length === 0
      )
        modeAcompte = true;

      const quittanceLignes = imputationManuelle
        ? this.state.quittanceLignes
        : quittance.quittance_ligne.sort(
          (a, b) =>
            a.quittance_ligne_rubrique.rubrique_ordre - b.quittance_ligne_rubrique.rubrique_ordre
        );

      // Répartition pro‑rata (sauf imputation manuelle)
      if (imputationManuelle) {
        // Conserver l'imputation manuelle mais en respectant le montant restant
        quittanceLignes.forEach((quittance_ligne) => {
          const montant = parseFloat(quittance_ligne.montant || 0);
          if (montantRestant > 0) {
            const quittance_ligne_montant =
              montant * parseInt(quittance_ligne.quittance_ligne_quantite);
            const part = Math.min(montantRestant, quittance_ligne_montant);
            if (part > 0) {
              reglementsLignes.push({
                reglement_ligne_reglement_id: reglement.reglement_id,
                reglement_ligne_quittance_ligne_id: quittance_ligne.quittance_ligne_id,
                reglement_ligne_quittance_ligne: quittance_ligne,
                reglement_ligne_montant: part,
                locataire_compte_id:
                  location.location_requete.requete_locataire.locataire_affectations[0]
                    .locataire_affectation_compte_id,
                proprietaire_compte_id:
                  location.location_lot.lot_proprietaire.proprietaire_affectations[0]
                    .proprietaire_affectation_compte_id,
              });
              montantRestant -= part;
            }
          }
        });
      } else {
        // 1) Calcul du montant de référence par ligne (acompte si applicable)
        const lignesAvecDue = quittanceLignes.map((quittance_ligne) => {
          let base = 0;
          if (modeAcompte) {
            const locationLigne = location.location_ligne.find(
              (ligne) =>
                ligne.location_ligne_rubrique.rubrique_id ===
                quittance_ligne.quittance_ligne_rubrique.rubrique_id
            );
            base = locationLigne
              ? parseFloat(
                  parseFloat(
                    quittance_ligne.quittance_ligne_montant *
                      quittance_ligne.quittance_ligne_quantite
                  ) * parseFloat(locationLigne.location_ligne_pourcentage_acompte)
                ) / 100
              : 0;
          } else {
            base = quittance_ligne.quittance_ligne_montant;
          }

          let totalLigne = parseFloat(base) * parseInt(quittance_ligne.quittance_ligne_quantite);

          // Déduire les montants déjà imputés sur cette ligne
          let dejaImpute = 0;
          lignesReglements.forEach((ligne) => {
            if (
              ligne.reglement_ligne_quittance_ligne_id.quittance_ligne_id ===
              quittance_ligne.quittance_ligne_id
            ) {
              dejaImpute += parseFloat(ligne.reglement_ligne_montant);
            }
          });

          const due = Math.max(0, totalLigne - dejaImpute);
          return { quittance_ligne, due };
        }).filter((x) => x.due > 0);

        // Rien à répartir
        if (montantRestant > 0 && lignesAvecDue.length > 0) {
          const sommeDue = lignesAvecDue.reduce((acc, x) => acc + x.due, 0);

          // 2) Si le montant à répartir dépasse la somme due, on n'impute que jusqu'au dû
          const montantARepartir = Math.min(montantRestant, sommeDue);

          // 3) Allocation pro‑rata sans arrondi; gérer un éventuel résiduel sur la dernière ligne
          let totalAttribue = 0;
          lignesAvecDue.forEach((item, idx) => {
            const isLast = idx === lignesAvecDue.length - 1;
            let part = isLast
              ? montantARepartir - totalAttribue
              : (montantARepartir * item.due) / sommeDue;

            // Ne pas dépasser le dû de la ligne
            if (part > item.due) part = item.due;
            if (part <= 0) return;

            reglementsLignes.push({
              reglement_ligne_reglement_id: reglement.reglement_id,
              reglement_ligne_quittance_ligne_id: item.quittance_ligne.quittance_ligne_id,
              reglement_ligne_quittance_ligne: item.quittance_ligne,
              reglement_ligne_montant: part,
              locataire_compte_id:
                location.location_requete.requete_locataire.locataire_affectations[0]
                  .locataire_affectation_compte_id,
              proprietaire_compte_id:
                location.location_lot.lot_proprietaire.proprietaire_affectations[0]
                  .proprietaire_affectation_compte_id,
            });
            totalAttribue += part;
          });

          // Mettre à jour le restant (le surplus éventuel sera géré comme trop perçu ailleurs)
          montantRestant -= montantARepartir;
        }
      }
    });
    return reglementsLignes;
  };

  onFinishReglement = (values) => {
    this.setState({ loading: true }, () => this.createReglement(values));
  };

  createReglement = (values) => {
    //console.log(values.date.format("YYYY-MM-DD"));
    let du = 0;
    const selectedRowKeys = this.state.selectedRowKeys;
    const montants = this.state.montants;
    // get selected montant quittance on Table
    const selectedMontants = montants.filter((item) => selectedRowKeys.includes(item.id));
    // value peut être une chaîne ("0", "0.00") ou null : on exige un montant strictement positif
    if (
      selectedMontants.length > 0 &&
      !selectedMontants.some((montants) => !(parseFloat(montants.value) > 0))
    ) {
      // get typePaiement Object
      const typePaiementObject = this.props.typesPaiements.find(
        (item) => item.type_paiement_id === parseInt(values.typePaiement)
      );
      // Prepare reglements
      const reglements = selectedMontants.map((element) => {
        du += parseFloat(element.du);
        return {
          reglement_banque: values.banque ? values.banque : "",
          reglement_tire: values.tire,
          reglement_numero_cheque: values.numero_cheque ? values.numero_cheque : "",
          //reglement_date: values.date,
          reglement_date: values.date.format("YYYY-MM-DD"),
          reglement_trop_percu: this.state.tropPercu,
          reglement_montant: element.value,
          reglement_bordereau: typePaiementObject.type_paiement_bordereau ? true : false,
          reglement_reddition: false,
          reglement_groupe_par: 0,
          reglement_type_paiement_id: parseInt(typePaiementObject.type_paiement_id),
          reglement_quittance_id: element.id,
          reglement_journal_id: values.ecriture_journal_id,
        };
      });
      //console.log(reglements);
      const journal = this.props.journals.find(
        (item) => item.journal_id === values.ecriture_journal_id
      );
      if (journal.journal_compte) {
        // Send requests
        this.props.saveReglement({ reglements: reglements })
          .then((res) => {
            // Prepare ligne reglement
            const reglementsLignes = this.prepareReglementsLignes(res);
            this.props.saveReglementLigne({ reglementsLignes: reglementsLignes }).then(() => {
              toast.success("Encaissement validé", { containerId: "A" });
            });
            const ecritureQuittance = this.getEcritureQuittance(
              res,
              values.tire,
              values.date,
              this.props.comptes.find((compte) => compte.compte_compte_general === "480000")
                .compte_id,
              reglementsLignes[0].locataire_compte_id
            );

            this.props
              .saveEcriture(ecritureQuittance)
              .then(() => {
                if (!typePaiementObject.type_paiement_bordereau) {
                  const ecritureBanque = this.getEcritureBanque(
                    res,
                    reglementsLignes,
                    `${typePaiementObject.type_paiement_libelle} ${
                      parseFloat(values.montant_reglement) < parseFloat(du) ? "acompte" : "solde"
                    } du ${dayjs(values.date).format("DD/MM/YYYY")} (${this.state.nomLocataire} ${this.state.prenomLocataire})`,
                    parseFloat(values.montant_reglement),
                    parseFloat(values.montant_reglement) - parseFloat(du),
                    values.date,
                    this.props.comptes.find(
                      (compte) =>
                        compte.compte_compte_general === journal.journal_compte.compte_compte_general
                    ).compte_id,
                    reglementsLignes[0].locataire_compte_id
                  );

                  this.props
                    .saveEcriture(ecritureBanque)
                    .then(() => {
                      // Construire et enregistrer l'écriture des honoraires (journal 70)
                      const ecritureHonoraires = this.getEcritureHonoraires(
                        res,
                        reglementsLignes,
                        values.date
                      );
                      if (ecritureHonoraires) {
                        this.props
                          .saveEcriture(ecritureHonoraires)
                          .then(() => this.reset())
                          .catch(() =>
                            toast.error("Erreur création écriture honoraires !", { containerId: "A" })
                          );
                      } else {
                        this.reset();
                      }
                    })
                    .catch(() =>
                      toast.error("Erreur création écriture banque !", { containerId: "A" })
                    );
                } else {
                  // Cas bordereau: pas d'écriture banque, mais on passe l'écriture honoraires
                  const ecritureHonoraires = this.getEcritureHonoraires(
                    res,
                    reglementsLignes,
                    values.date
                  );
                  if (ecritureHonoraires) {
                    this.props
                      .saveEcriture(ecritureHonoraires)
                      .then(() => this.reset())
                      .catch(() =>
                        toast.error("Erreur création écriture honoraires !", { containerId: "A" })
                      );
                  } else {
                    this.reset();
                  }
                }
              })
              .catch(() => toast.error("Erreur création écriture quittance !", { containerId: "A" }));
          });
      } else {
        this.setState({ loading: false }, () =>
          toast.error("Le jounal sélectionné n'a pas de compte de contrepartie !", {
            containerId: "A",
          })
        );
      }
    } else {
      this.setState({ loading: false }, () =>
        toast.error("Un des règlements est à 0, validation impossible !", {
          containerId: "A",
        })
      );
    }
  };

  getEcritureQuittance = (reglements, libelle, date, compteQuittance, compteLocataire) => {

    // Journal Quittance 48
    const journal48 = this.props.journals.find((j) => j.journal_code === "48");
    const ecritureLignes = [];
    let montant = 0;
    reglements.forEach((reglement) => {
      const debit = {
        ecriture_ligne_libelle: libelle,
        ecriture_ligne_montant_debit: parseFloat(reglement.reglement_montant),
        ecriture_ligne_montant_credit: 0,
        ecriture_ligne_compte_id: compteQuittance,
        ecriture_ligne_locataire_code: "",
        ecriture_ligne_en_reddition: false,
      };
      montant += parseFloat(reglement.reglement_montant);
      ecritureLignes.push(debit);
    });
    const credit = {
      ecriture_ligne_libelle: libelle,
      ecriture_ligne_montant_debit: 0,
      ecriture_ligne_montant_credit: montant,
      ecriture_ligne_compte_id: compteLocataire,
      ecriture_ligne_locataire_code: "",
      ecriture_ligne_en_reddition: false,
    };
    ecritureLignes.push(credit);
    const ecriture = {
      ecriture_journal_id: journal48.journal_id,
      ecriture_date_ecriture: dayjs(date).format('YYYY-MM-DD'),
      ecriture_libelle: libelle,
      ecriture_action: reglements.map((reglement) => `REG${reglement.reglement_id}`).join("|"),
      ecriture_ligne: ecritureLignes,
    };
    return ecriture;
  };

  getEcritureBanque = (
    reglements,
    lignes,
    libelle,
    montant,
    montantTropPercu,
    date,
    compteBanque,
    compteLocataire
  ) => {
    let ecritureLignes = [];
    const ligneDebit = {
      ecriture_ligne_libelle: libelle,
      ecriture_ligne_montant_debit: montant,
      ecriture_ligne_montant_credit: 0,
      ecriture_ligne_compte_id: compteBanque,
      ecriture_ligne_locataire_code: "",
      ecriture_ligne_en_reddition: false,
    };
    ecritureLignes.push(ligneDebit);
    ecritureLignes = ecritureLignes.concat(this.getLignesCredit(lignes, libelle));

    if (montantTropPercu > 0) {
      const ligneTropPercu = {
        ecriture_ligne_libelle: libelle,
        ecriture_ligne_montant_debit: 0,
        ecriture_ligne_montant_credit: montantTropPercu,
        ecriture_ligne_compte_id: this.props.comptes.find(
          (compte) => compte.compte_compte_general === "467001"
        ).compte_id,
        ecriture_ligne_locataire_code: `${
          this.props.comptes.find((compte) => compte.compte_id === compteLocataire)
            .compte_compte_auxiliaire
        }`,
        ecriture_ligne_en_reddition: false,
      };
      ecritureLignes.push(ligneTropPercu);
    }
    const ecritureBanque = {
      ecriture_journal_id: this.state.journal,
      ecriture_date_ecriture: dayjs(date).format('YYYY-MM-DD'),
      ecriture_libelle: libelle,
      ecriture_action: reglements.map((reglement) => `REG${reglement.reglement_id}`).join("|"),
      ecriture_ligne: ecritureLignes,
    };
    return ecritureBanque;
  };

  getLignesCredit = (lignes, libelle) => {
    // Dans l'écriture banque, TOUT est crédité au(x) propriétaire(s),
    // y compris la part des honoraires (extraction faite dans une écriture séparée journal 70).
    const regroupement = lignes.reduce((acc, ligne) => {
      const compteId = `proprietaire_${ligne.proprietaire_compte_id}`;

      if (acc[compteId]) {
        acc[compteId] += parseFloat(ligne.reglement_ligne_montant);
      } else {
        acc[compteId] = parseFloat(ligne.reglement_ligne_montant);
      }

      return acc;
    }, {});

    return Object.entries(regroupement).map(([key, values]) => ({
      ecriture_ligne_libelle: libelle,
      ecriture_ligne_montant_debit: 0,
      ecriture_ligne_montant_credit: values,
      ecriture_ligne_compte_id: parseInt(key.split("_")[1]),
      ecriture_ligne_locataire_code: "",
      ecriture_ligne_en_reddition: false,
    }));
  };

  // Construit l'écriture des honoraires: Débit propriétaire(s) / Crédit 468001 au journal 70
  getEcritureHonoraires = (reglements, lignes, date) => {
    // Regrouper les honoraires par propriétaire
    const regroupement = lignes
      .filter(
        (ligne) =>
          ligne.reglement_ligne_quittance_ligne.quittance_ligne_rubrique.rubrique_type === "G"
      )
      .reduce((acc, l) => {
        const key = l.proprietaire_compte_id;
        const val = parseFloat(l.reglement_ligne_montant);
        acc[key] = (acc[key] || 0) + val;
        return acc;
      }, {});

    const totalHonoraires = Object.values(regroupement).reduce((a, b) => a + b, 0);
    if (!totalHonoraires || totalHonoraires === 0) return null;

    const compte468 = this.props.comptes.find((c) => c.compte_compte_general === "468001");
    const journal70 = this.props.journals.find((j) => j.journal_code === "70");
    if (!compte468 || !journal70) return null;

    const ecritureLignes = [];
    // Débits par propriétaire
    Object.entries(regroupement).forEach(([proprioId, montant]) => {
      ecritureLignes.push({
        ecriture_ligne_libelle: `Honoraires sur location (${this.state.nomLocataire} ${this.state.prenomLocataire})`,
        ecriture_ligne_montant_debit: montant,
        ecriture_ligne_montant_credit: 0,
        ecriture_ligne_compte_id: parseInt(proprioId, 10),
        ecriture_ligne_locataire_code: "",
        ecriture_ligne_en_reddition: false,
      });
    });
    // Crédit 468001 pour le total
    ecritureLignes.push({
      ecriture_ligne_libelle: `Honoraires sur location (${this.state.nomLocataire} ${this.state.prenomLocataire})`,
      ecriture_ligne_montant_debit: 0,
      ecriture_ligne_montant_credit: totalHonoraires,
      ecriture_ligne_compte_id: compte468.compte_id,
      ecriture_ligne_locataire_code: "",
      ecriture_ligne_en_reddition: false,
    });

    return {
      ecriture_journal_id: journal70.journal_id,
      ecriture_date_ecriture: dayjs(date).format("YYYY-MM-DD"),
      ecriture_libelle: `Honoraires sur location (${this.state.nomLocataire} ${this.state.prenomLocataire})`,
      ecriture_action: reglements.map((reglement) => `REG${reglement.reglement_id}`).join("|"),
      ecriture_ligne: ecritureLignes,
    };
  };


  getEcritureAvecSelectedRows = (selectedMontants) => {
    // Enrichir selectedMontants avec les données complètes des selectedRows
    const selectedRows = this.state.selectedRows;

    return selectedMontants.map(montant => {
      const row = selectedRows.find(r => r.quittance_id === montant.id);
      return {
        ...(row || {}),
        montant_saisi: montant.value
      };
    });
  };

  checkTopPercu = (array, du) => {
    let montantReglement = 0;
    array.length && array.forEach((m) => (montantReglement += m.value));
    this.setState({ tropPercu: montantReglement > du });
  };

  setMontantReglement = (array) => {
    let montantReglement = 0;
    array.length && array.forEach((m) => (montantReglement += parseFloat(m.value)));
    this.formRef.current.setFieldsValue({
      montant_reglement: parseFloat(montantReglement).toFixed(2),
    });
    return parseFloat(montantReglement).toFixed(2);
  };

  reglementChange = (data) => {
    // Set montant state
    this.setState((state) => {
      const quittance = state.reglements.filter((item) => item.quittance_id === data.id);
      state.montants.map((item) => {
        if (item.id === quittance.quittance_id) {
          item.value = data.value;
          item.du = data.du;
        }
        return item;
      });
    });
    // set Montant total
    let newMontants = [];
    const exist =
      this.state.montants.length &&
      this.state.montants.filter((item) => item.id === data.id).length > 0;
    if (exist) {
      const montantsRefresh = this.state.montants.map((item) => {
        if (item.id === data.id) {
          item.value = data.value;
          item.du = data.du;
        }
        return item;
      });
      newMontants = montantsRefresh;
    } else {
      newMontants = [...this.state.montants, data];
    }

    this.setState({ montantReglement: data.value, montants: newMontants });

    const newSelectedRowKeys = parseFloat(data.value) > 0 ? this.checkReglement(data.id) : [];

    const selectedMontants = newMontants.filter((item) => newSelectedRowKeys.includes(item.id));
    this.checkTopPercu(selectedMontants, data.du);
    this.setMontantReglement(selectedMontants);
  };

  checkReglement = (id) => {
    const exist = this.state.selectedRowKeys.filter((item) => item === id).length > 0;
    const newSelectedRowKeys = exist
      ? this.state.selectedRowKeys
      : [...this.state.selectedRowKeys, id];

    // Synchroniser selectedRows avec selectedRowKeys
    const newSelectedRows = this.state.reglements.filter(regl =>
      newSelectedRowKeys.includes(regl.quittance_id)
    );

    this.setState({
      selectedRowKeys: newSelectedRowKeys,
      selectedRows: newSelectedRows,
    });
    return newSelectedRowKeys;
  };

  uncheckReglement = (id) => {
    const selectedRowKeysFiltered = this.state.selectedRowKeys.filter((item) => item !== id);

    // Synchroniser selectedRows avec selectedRowKeys
    const selectedRowsFiltered = this.state.selectedRows.filter((item) => item.quittance_id !== id);

    this.setState({
      selectedRowKeys: selectedRowKeysFiltered,
      selectedRows: selectedRowsFiltered,
      quittanceLignes: []
    });
    return selectedRowKeysFiltered;
  };

  uncheckAll = () => {
    this.setState({ selectedRowKeys: [] });
  };

  resetReglements = () => {
    const newMontants = this.state.montants.map((item) => {
      item.value = null;
      return item;
    });
    this.formRef.current.resetFields([
      "requete_locataire_id",
      // "date",
      // "typePaiement",
      "banque",
      "numero_cheque",
      "tire",
      "montant_reglement",
    ]);
    this.handleLocataire(null);
    this.setState({ montants: newMontants, libelle: "", isAcompte: false });
  };

  onChangeTypePaiement = (value) => {
    const typePaiement = this.props.typesPaiements.find(
      (item) => item.type_paiement_id === parseInt(value)
    );
    this.setState(
      { typePaiement: value, hidden: typePaiement.type_paiement_libelle === "Chèque" },
      () => this.onChangeLibelle()
    );

    if (typePaiement.type_paiement_journal) {
      const journal = this.props.journals.find(
        (item) => item.journal_id === typePaiement.type_paiement_journal.journal_id
      );
      journal && this.onChangeJournal(journal.journal_id);
      journal &&
      this.formRef.current.setFieldsValue({
        ecriture_journal_id: journal.journal_id,
      });
    } else {
      const journal = this.props.journals.find((item) => item.journal_de_banque === true);
      this.onChangeJournal(journal.journal_id);
      this.formRef.current.setFieldsValue({
        ecriture_journal_id: journal.journal_id,
      });
    }
  };

  onChangeDateReglement = (value) => {
    //console.log(value);
    this.setState({ dateReglement: value }, () => this.onChangeLibelle());
  };

  onChangeNumeroCheque = (e) => {
    this.setState({ numeroCheque: e.target.value }, () => this.onChangeLibelle());
  };

  onChangeLibelle = () => {
    const { typePaiement, numeroCheque, dateReglement, nomLocataire, prenomLocataire } = this.state;
    const typePaiementObject = this.props.typesPaiements.find(
      (item) => item.type_paiement_id === parseInt(typePaiement)
    );
    const stringTypePaiement = typePaiementObject.type_paiement_libelle;
    const libelle = `${stringTypePaiement}${
      typePaiementObject.type_paiement_libelle === "Chèque" ? ` n°${numeroCheque}` : ""
    } du ${
      dateReglement ? dayjs(dateReglement, "DD/MM/YYYY").format("DD/MM/YYYY") : "?"
    } (${nomLocataire} ${prenomLocataire})`;
    this.formRef.current.setFieldsValue({
      tire: libelle,
    });
    this.setState({ libelle });
  };

  /*acompte = (quittance) => {
    const data = {
      id: quittance.quittance_id,
      value: quittance.acompte,
      du: quittance.du,
    };
    this.setState({ quittanceLignes: [], isAcompte: true }, () => {
      this.reglementChange(data);
      // S'assurer que la ligne est sélectionnée
      const newSelectedRowKeys = this.checkReglement(quittance.quittance_id);
      const newSelectedRows = this.state.reglements.filter(regl =>
        newSelectedRowKeys.includes(regl.quittance_id)
      );
      this.setState({ selectedRows: newSelectedRows });
    });
  };*/

  solde = (quittance) => {
    const data = {
      id: quittance.quittance_id,
      value: quittance.du,
      du: quittance.du,
    };
    this.setState({ quittanceLignes: [], isAcompte: false }, () => {
      this.reglementChange(data);
      // S'assurer que la ligne est sélectionnée
      const newSelectedRowKeys = this.checkReglement(quittance.quittance_id);
      const newSelectedRows = this.state.reglements.filter(regl =>
        newSelectedRowKeys.includes(regl.quittance_id)
      );
      this.setState({ selectedRows: newSelectedRows });
    });
  };

  getReglement = (quittance_id) => {
    const quittanceLignesReglement = this.state.quittanceLignes.filter(
      (ligne) => ligne.quittance_id === quittance_id
    );
    if (quittanceLignesReglement.length > 0) {
      return quittanceLignesReglement.reduce((a, b) => a + parseFloat(b.montant), 0);
    }
    const montant = this.state.montants.filter((item) => item.id === quittance_id);
    return montant.length && parseFloat(montant[0].value);
  };

  reglement = (quittance, value) => {
    const data = {
      id: quittance.quittance_id,
      value: value,
      du: quittance.du,
    };
    this.reglementChange(data);
    if (value == null || value === "" || value <= 0) {
      this.uncheckReglement(quittance.quittance_id);
    } else {
      this.checkReglement(quittance.quittance_id);
      // PROBLEME ICI : selectedRows n'est pas mis à jour.
      // Il faut aussi mettre à jour selectedRows avec la ligne complète
      const updatedSelectedRows = this.state.reglements.filter(regl =>
        [...this.state.selectedRowKeys, quittance.quittance_id].includes(regl.quittance_id)
      );
      this.setState({ selectedRows: updatedSelectedRows });
    }
    this.setState({ quittanceLignes: [], isAcompte: false });
  };

  handleLocataire = (idLocataire) => {
    this.setState({ idLocataire });
    this.onSelectLocataire(idLocataire);
  };

  handleOpenChange = (newOpen) => {
    if (!newOpen) {
      this.setState({ popConfirmOpen: newOpen });
      return;
    }

    if (!this.state.tropPercu) {
      this.popConfirmConfirm();
    } else {
      this.setState({ popConfirmOpen: newOpen });
    }
  };

  popConfirmConfirm = () => {
    this.formRef.current.submit();
    this.setState({ popConfirmOpen: false });
  };

  popConfirmCancel = () => {
    this.setState({ popConfirmOpen: false });
  };

  render() {
    const { journals, locataires, typesPaiements } = this.props;
    const {
      journal,
      montants,
      reglements,
      selectedRowKeys,
      hidden,
      nomLocataire,
      dateReglement,
      typePaiement,
      numeroCheque,
      libelle,
      montantReglement,
      popConfirmOpen,
      loading,
    } = this.state;

    const reglementsActif = reglements.filter((regl) => regl.du > 0);
    //console.log(reglementsActif);

    const rowSelection = {
      onChange: (selectedRowKeys, selectedRows) => {
        this.setState({ selectedRowKeys, selectedRows });
        const selectedMontants = montants.filter((item) => selectedRowKeys.includes(item.id));
        this.setMontantReglement(selectedMontants);

        //console.log('Lignes sélectionnées:', selectedRows);
      },
      selectedRowKeys: selectedRowKeys,
    };

    return (
      <Form ref={this.formRef} onFinish={this.onFinishReglement} style={{ padding: "20px" }}>
        <Row gutter={10}>
          <Col span={12}>
            <CustomSelect
              label="Journal"
              inputName="ecriture_journal_id"
              formItemName="ecriture_journal_id"
              objectValue={journal}
              onChange={(id) => this.onChangeJournal(id)}
            >
              <OptGroup label="Journal">
                {journals &&
                  journals.map((item, i) => {
                    return (
                      <Option
                        key={i}
                        value={item.journal_id}
                        label={item.journal_code + " - " + item.journal_libelle}
                      >
                        <Row>
                          <Col sm={8}>
                            {item.journal_code} - {item.journal_libelle}
                          </Col>
                        </Row>
                      </Option>
                    );
                  })}
              </OptGroup>
            </CustomSelect>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <CustomSelect
              label="Locataire"
              inputName="requete_locataire_id"
              formItemName="requete_locataire_id"
              onSelect={this.handleLocataire}
              filterOption={(input, option) =>
                option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              objectValue={nomLocataire}
            >
              <OptGroup label="Locataire">
                {locataires &&
                  locataires.map((item, i) => {
                    return (
                      <Option
                        key={i}
                        value={item.locataire_id}
                        label={getInfoLocataireSimple(item)}
                      >
                        <Row>
                          <Col sm={8}>{getInfoLocataireSimple(item)}</Col>
                        </Row>
                      </Option>
                    );
                  })}
              </OptGroup>
            </CustomSelect>
          </Col>
        </Row>
        <Row gutter={10}>
          <Col span={6}>
            <CustomDatePicker
              label="Date"
              inputName="date"
              formItemName="date"
              objectValue={dateReglement}
              onChange={this.onChangeDateReglement}
              rules={{ required: true, message: "Date obligatoire" }}
            />
          </Col>
          <Col span={6}>
            <CustomSelect
              label="Type de paiement"
              inputName="typePaiement"
              formItemName="typePaiement"
              onChange={this.onChangeTypePaiement}
              objectValue={typePaiement}
            >
              <OptGroup label="Type de paiement">
                {typesPaiements &&
                  typesPaiements
                    .map((item, i) => {
                      return (
                        <Option
                          key={i}
                          value={item.type_paiement_id}
                          label={item.type_paiement_libelle}
                        >
                          <Row>
                            <Col sm={8}>{item.type_paiement_libelle}</Col>
                          </Row>
                        </Option>
                      );
                    })}
              </OptGroup>
            </CustomSelect>
          </Col>
          {hidden && (
            <Col span={6}>
              <CustomInput
                label="Banque"
                inputName="banque"
                formItemName="banque"
                objectValue={null}
              />
            </Col>
          )}
          {hidden && (
            <Col span={6}>
              <CustomInput
                label="Numéro chèque"
                inputName="numero_cheque"
                formItemName="numero_cheque"
                objectValue={numeroCheque}
                onChange={this.onChangeNumeroCheque}
              />
            </Col>
          )}
        </Row>
        <Row gutter={10}>
          <Col md={12}>
            <CustomInput
              label="Libellé"
              inputName="tire"
              formItemName="tire"
              objectValue={libelle}
            />
          </Col>
          <Col md={12}>
            <CustomInput
              label="Montant règlement"
              inputName="montant_reglement"
              formItemName="montant_reglement"
              type="number"
              readOnly={true}
              objectValue={montantReglement}
            />
          </Col>
        </Row>
        <Row style={{ marginTop: "10px" }}>
          <Table
            dataSource={reglementsActif}
            rowSelection={{
              type: "checkbox",
              ...rowSelection,
            }}
            rowKey="quittance_id"
            scroll={{ y: 512 }}
            size="small"
          >
            <Column title="N° Quittance" dataIndex="quittance_id" key="quittance_id" />
            <Column title="N° Contrat" dataIndex="location_id" key="location_id" />
            <Column title="Appartement" dataIndex="appartement" key="appartement" />
            <Column title="Arrivée" dataIndex="date_debut" key="date_debut" />
            <Column title="Départ" dataIndex="date_fin" key="date_fin" />
            <Column title="Montant Total" dataIndex="total" key="total" />
            <Column title="Montant réglé" dataIndex="paye" key="paye" />
            <Column title="Solde dû" dataIndex="du" key="du" />
            <Column
              title="Règlement"
              dataIndex="quittance_id"
              key="reglement"
              render={(quittance_id, quittance) => (
                <InputNumber
                  onChange={(value) => this.reglement(quittance, value)}
                  value={this.getReglement(quittance.quittance_id)}
                  disabled={quittance.expand}
                />
              )}
            />
            <Column
              title="Solde Total"
              dataIndex="quittance_id"
              key="quittance_id"
              render={(quittance_id, quittance) => (
                <Button
                  icon={<ArrowLeftOutlined />}
                  onClick={() => this.solde(quittance)}
                  disabled={quittance.expand}
                />
              )}
            />
          </Table>
        </Row>
        <Row style={{ marginTop: "10px", float: "right" }}>
          <Popconfirm
            title={
              <div>
                <span>Attention, montant saisi supérieur au montant de la location ! </span>
                <br />
                <span>
                  A la validation, cette différence sera créditée sur le compte de Trop perçu
                  (467001)
                </span>
                <br />
                <span>Etes vous sûr de vouloir confirmer cet encaissement ?</span>
              </div>
            }
            open={popConfirmOpen}
            onOpenChange={this.handleOpenChange}
            onConfirm={this.popConfirmConfirm}
            onCancel={this.popConfirmCancel}
            okText="Oui"
            cancelText="Non"
            disabled={!selectedRowKeys.length > 0}
          >
            <Button loading={loading} type="primary" disabled={!selectedRowKeys.length > 0}>
              Valider
            </Button>
          </Popconfirm>
        </Row>
      </Form>
    );
  }
}

export default FormReglement;
